namespace $.$$ {

	export class $shm_wordstat_chart_timeseries extends $.$shm_wordstat_chart_timeseries {

		option() {
			const rows = this.rows() as readonly ( readonly [ string, number, string? ] )[]
			const dates = [ ... new Set( rows.map( row => row[0] ) ) ]
			const date_titles = dates.map( date => this.date_title( date ) )
			const series_names = [ ... new Set( rows.map( row => row[2] || this.title() ) ) ]
			const values = new Map( rows.map( row => [ `${ row[2] || this.title() }\n${ row[0] }`, row[1] ] ) )
			return {
				tooltip: { trigger: 'axis', order: 'valueDesc' },
				legend: { type: 'scroll', top: 0 },
				toolbox: {
					show: false,
					feature: {
						brush: {
							show: false,
						},
					},
				},
				brush: {
					toolbox: [],
					xAxisIndex: 0,
					brushMode: 'single',
					brushType: 'lineX',
					transformable: false,
					throttleType: 'debounce',
					throttleDelay: 200,
				},
				grid: { left: 8, right: 24, top: 48, bottom: 48, containLabel: true },
				xAxis: { type: 'category', data: date_titles },
				yAxis: { type: 'value' },
				series: series_names.map( name => ({
					name,
					type: 'line',
					showSymbol: true,
					symbolSize: 6,
					cursor: 'pointer',
					data: dates.map( date => values.get( `${ name }\n${ date }` ) ?? 0 ),
				}) ),
			}
		}

		date_title( date: string ) {
			const match = String( date ).match( /^(\d{4})-(\d{2})-(\d{2})/ )
			if( !match ) return date
			if( this.period_kind() === 'PERIOD_MONTHLY' ) return `${ match[1] }-${ match[2] }`
			if( this.period_kind() === 'PERIOD_WEEKLY' ) {
				const interval = this.date_interval( date )
				return `${ this.date_title_day( interval.from ) }\n- ${ this.date_title_day( interval.to ) }`
			}
			return this.date_title_day( date )
		}

		date_title_day( date: string ) {
			const match = String( date ).match( /^(\d{4})-(\d{2})-(\d{2})/ )
			return match ? `${ match[3] }.${ match[2] }.${ match[1] }` : date
		}

		date_shift( date: string, shift: ( value: Date )=> void ) {
			const value = new Date( `${ date.slice( 0, 10 ) }T00:00:00Z` )
			if( Number.isNaN( value.getTime() ) ) return date
			shift( value )
			return value.toISOString().slice( 0, 10 )
		}

		date_interval( date: string ) {
			const from = date.slice( 0, 10 )
			if( this.period_kind() === 'PERIOD_MONTHLY' ) return {
				from,
				to: this.date_shift( from, value => {
					value.setUTCMonth( value.getUTCMonth() + 1 )
					value.setUTCDate( 0 )
				} ),
			}
			if( this.period_kind() === 'PERIOD_WEEKLY' ) return {
				from,
				to: this.date_shift( from, value => value.setUTCDate( value.getUTCDate() + 6 ) ),
			}
			return { from, to: from }
		}

		brush_cursor() {
			return {
				brushType: 'lineX',
				brushMode: 'single',
			}
		}

		brush_end( next?: any ) {
			if( next === undefined ) return null

			const dates = this.date_list()
			if( dates.length <= 1 ) return next

			const area = this.brush_area( next )
			const range = area?.coordRange ?? area?.range
			if( !Array.isArray( range ) || range.length < 2 ) return next

			const from = this.brush_index( range[0] )
			const to = this.brush_index( range[1] )
			if( from === null || to === null ) return next

			const first = Math.max( 0, Math.min( from, to ) )
			const last = Math.min( dates.length - 1, Math.max( from, to ) )
			if( first > last ) return next

			this.period_range_pick([
				this.date_interval( dates[ first ] ).from,
				this.date_interval( dates[ last ] ).to,
			])
			return next
		}

		point_click( next?: any ) {
			if( next === undefined ) return null
			if( next.event?.event?.button !== undefined && next.event.event.button !== 0 ) return next

			const index = Number( next.dataIndex )
			const date = this.date_list()[ index ]
			if( date ) {
				const interval = this.date_interval( date )
				this.period_range_pick([ interval.from, interval.to ])
			}
			return next
		}

		date_list() {
			const rows = this.rows() as readonly ( readonly [ string, number, string? ] )[]
			return [ ... new Set( rows.map( row => row[0] ) ) ]
		}

		brush_area( next: any ) {
			return next.areas?.[0] ?? next.batch?.[0]?.areas?.[0] ?? null
		}

		brush_index( value: unknown ) {
			if( typeof value === 'number' && Number.isFinite( value ) ) return Math.round( value )
			const text = String( value )
			const index = this.date_list().findIndex( date => date === text || this.date_title( date ) === text )
			return index >= 0 ? index : null
		}

	}

}
